import { render, staticRenderFns } from "./SectionSubQuiz.vue?vue&type=template&id=56f6642a&scoped=true&"
import script from "./SectionSubQuiz.vue?vue&type=script&lang=js&"
export * from "./SectionSubQuiz.vue?vue&type=script&lang=js&"
import style0 from "./SectionSubQuiz.vue?vue&type=style&index=0&id=56f6642a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f6642a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f6642a')) {
      api.createRecord('56f6642a', component.options)
    } else {
      api.reload('56f6642a', component.options)
    }
    module.hot.accept("./SectionSubQuiz.vue?vue&type=template&id=56f6642a&scoped=true&", function () {
      api.rerender('56f6642a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/albert/albertactionplan/SectionSubQuiz.vue"
export default component.exports